import { Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import Iconify from "../../components/iconify/Iconify";

export default function OrderMoreOptionsMenu({
  anchorEl,
  open,
  onClose,
  activeOrderId,
  onActivityClick,
}) {
  return (
    <Menu
      anchorOrigin={{
        horizontal: "left",
        vertical: "center",
      }}
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
    >
      <MenuItem
        disabled={!activeOrderId}
        onClick={() => {
          onClose();
          onActivityClick && onActivityClick();
        }}
      >
        <ListItemIcon>
          <Iconify icon="mdi:clipboard-text-clock-outline" />
        </ListItemIcon>
        <ListItemText primary="Activity Log" />
      </MenuItem>

      {/* You can easily add more shared items here */}
    </Menu>
  );
}
